import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { MACRO_MEDIA_BASE } from '../../_shared/data/media';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';
import { buildBrandLogos } from '../../_shared/images/brand-logos';

export const macroSelecta1080x1920: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#000',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),

    // Shape blanca
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/selecta/shape.svg`,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 870,
      targetWidth: 962,
      targetHeight: 1300
    },

    // Símbolo de porcentaje
    {
      fontSize: 77,
      fontWeight: 'normal',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 787.3932,
      top: 578.0716,
      width: 97.7724,
      height: 87.01,
      fill: '#000',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Doble pill
    buildPillPair({
      left: { pieceId: 'category', text: 'TRANSPORTE', style: 'white-black-text' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'gold-white-text' },
      fontSize: 35,
      paddingX: 21.882,
      paddingY: 7.294,
      strokeWidth: 1.824,
      position: { left: 540, top: 496.1966, width: 543.4602, height: 54.138 }
    }),

    // Número de descuento
    buildDiscountValue({
      pieceId: 'discount-value-a',
      text: '30',
      fontSize: 437.7393915368539,
      fontWeight: 'normal',
      fill: '#000',
      position: { left: 540, top: 722.9044, width: 757.5107, height: 494.6455 }
    }),

    // Línea horizontal
    {
      pieceId: 'horizontal-line',
      rx: 0,
      ry: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 550,
      top: 1040.15,
      width: 140,
      height: 100,
      fill: 'rgb(0, 0, 0)',
      stroke: '#000',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 4.668,
      scaleY: 0.02,
      angle: 0,
      flipX: false,
      flipY: true,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Pill con texto del beneficio
    buildBenefitLabel({
      pieceId: 'benefit-label-a',
      text: 'de ahorro',
      fontSize: 36,
      position: { left: 767.382, top: 712.1436 },
      paddingX: 27,
      paddingY: 15,
      pillFill: 'rgb(199,180,125)',
      borderRadius: 30
    }),

    // Texto del método de pago
    buildPaymentMethodText({
      pieceId: 'payment-method-text-a',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 36,
      lineHeight: 0.96,
      textAlign: 'center',
      fill: '#000',
      position: { left: 540, top: 948.3606, width: 565.8991, height: 79.7328 }
    }),

    // Texto del tope
    buildLimitText({
      pieceId: 'limit-text-a',
      text: 'Tope $10.000 por cuenta, por mes.',
      fontSize: 20,
      position: { left: 540, top: 1060.3586, width: 640.4979, height: 22.6 }
    }),

    // Logos de marcas
    buildBrandLogos({
      position: { left: 540, top: 1199.8608, width: 600, height: 190 }
    }),

    // Texto del footer
    buildLimitText({
      pieceId: 'footer-text',
      text: '*Valido para pagos realizados a traves de la aplicacion por viajes efectuados dentro de EE.UU.',
      fontSize: 23,
      position: { left: 540, top: 1322.3481, width: 592.8212, height: 56.1384 }
    }),

    // Logo Macro
    {
      cropX: 0,
      cropY: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1611.7225,
      width: 8930,
      height: 3545,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0383,
      scaleY: 0.0383,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${MACRO_MEDIA_BASE}/logos/selecta-blanco.png`,
      crossOrigin: null,
      filters: []
    },

    // Texto con legales
    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 540, top: 1756.9107, width: 683, height: 25.99 }
    })
  ],
  background: 'transparent'
};
